import { z } from 'zod';
export const assistantPageContextTypes = [`policy`, `contact`, `invoice`];
/** What the user had open when they sent a message: a policy, customer or invoice page */
export const assistantPageContextSchema = z.object({
    type: z.enum(assistantPageContextTypes),
    id: z.string().min(1).max(64),
});
//# sourceMappingURL=assistantPageContext.js.map